import { LoaderSize } from './Loader.types';

export const SIZES_TO_PIXELS_MAP: Record<LoaderSize, number> = {
  tiny: 18,
  small: 30,
  medium: 54,
  large: 102,
};

export const SIZE_TO_STROKE_WIDTH_MAP: Record<LoaderSize, number> = {
  tiny: 3,
  small: 4,
  medium: 4,
  large: 4,
};

export const SIZE_TO_ARC_ANGLE_MAP: Record<
  LoaderSize,
  { light: number; dark: number }
> = {
  tiny: {
    light: 216,
    dark: 144,
  },
  small: {
    light: 216,
    dark: 144,
  },
  medium: {
    light: 108,
    dark: 108,
  },
  large: {
    light: 180,
    dark: 180,
  },
};
